import React, { Fragment, useState } from 'react';
import _identity from 'lodash/identity';
import _isEmpty from 'lodash/isEmpty';
import _pick from 'lodash/pick';
import _pickBy from 'lodash/pickBy';

import Table from 'components/customTable';

import ZpFilter from '../../../../components/zpFilter';
import { CAROUSEL_FILTERS,FILTER_PARAMS } from '../../../../components/zpFilter/filterUtils';
import CommonService from '../../../../services/commonService';
import { logEventGTM } from '../../../../utils/analyticsGTM';
import { JOB_BUCKET_GROUP } from '../../../../utils/constant';
import HorizontalBarChart from '../../charts/horizontalBarChart';

const xAxisLabels = ['0%', '20%', '40%', '60%', '80%', '100%'];

const Industries = ({
  jobTitle,
  industries,
  industryContentBlurb,
  filterValueRange,
  filterLogEventCallback,
  jobTitlePlural,
}) => {
  const yAxisLabels = industries.map(({ industrie }) =>
    _pickBy(
      {
        industrie,
      },
      _identity
    )
  );

  const values = industries.map(({ industriePercent }) => industriePercent);
  const tableData = industries.map((x) => ({
    ...x,
    industriePercentDisplay: x.industriePercent + '%',
  }));

  const [compareValues, setCompareValues] = useState([]);
  const [compareJobTitle, setCompareJobTitle] = useState('');

  const handleFilterUpdate = async (_, data) => {
    const { value = jobTitle } = data;
    const jobTitleComparisonValue = value.originalSearch ? value.originalSearch : value;

    if (jobTitleComparisonValue === jobTitle && _isEmpty(compareValues)) {
      return;
    } else if (jobTitleComparisonValue === jobTitle && !_isEmpty(compareValues)) {
      setCompareValues([]);
      setCompareJobTitle('');
      return;
    }

    try {
      const jobTitles = [jobTitleComparisonValue];
      const data = { jobTitles };
      const newIndustryTypes = await CommonService.fetchTitleIndustriesData(data);
      const newValues = [];
      yAxisLabels.forEach((label) => {
        const associateType = newIndustryTypes[0].find(
          (industryType) => industryType.industrie === label.industrie
        );
        newValues.push(associateType ? associateType.industriePercent : 0);
      });
      setCompareJobTitle(jobTitles[0]);
      setCompareValues(newValues);
    } catch (error) {
      console.log(error);
    }
  };

  const logShowMoreButtonClick = () => {
    logEventGTM({
      action: 'Show More Click',
      label: 'Industry Concentration Show More Click',
      event: 'User clicks the "Show More" button to see more industries',
    });
  };

  const filterProps = () => {
    const filterGroup = `${JOB_BUCKET_GROUP.CAREER_DEMOGRAPHICS_COMPARE_JOBS}-industries`;
    return {
      ...CAROUSEL_FILTERS[FILTER_PARAMS.JOB_TITLE],
      filterGroup,
      buttonText: 'Compare Jobs',
      valueRange: filterValueRange,
      onApply: handleFilterUpdate,
      onClear: handleFilterUpdate,
      options: {
        logEvent: () =>
          filterLogEventCallback(`${JOB_BUCKET_GROUP.CAREER_DEMOGRAPHICS_COMPARE_JOBS}-industries`),
      },
    };
  };

  return (
    <Fragment>
      <h3 className="cmpSectionh4 mb-3">{`Top Industries Hiring ${jobTitlePlural}`}</h3>
      {industryContentBlurb && industryContentBlurb.content && (
        <div
          className="mt-3 mb-4 w-635"
          dangerouslySetInnerHTML={{ __html: industryContentBlurb.content }}
        />
      )}
      <ZpFilter {...filterProps()} />
      <HorizontalBarChart
        tooltipKey={'industries'}
        yAxisLabels={yAxisLabels}
        xAxisLabels={xAxisLabels}
        values={values}
        compareValues={compareValues}
        yAxisLabelsWidth={'136px'}
        jobTitle={jobTitle}
        compareJobTitle={compareJobTitle}
        showMoreButton={true}
        showMoreButtonCallback={logShowMoreButtonClick}
      />
      <div className="mb-5 z-pt-48">
        <Table
          columnConfig={{
            industrie: {
              columnName: 'Industry',
              isLink: 'isLinkIndexed',
              linkUrl: 'link',
            },
            industriePercentDisplay: {
              columnName: 'Percentages',
              customSortByField: 'industriePercent',
              // defaultSortDirection: 'desc'
            },
          }}
          bodyData={tableData}
          defaultRowsDisplay={99}
          tableHeaderTitleContent={
            <h3 className="zp-title-h3 text-capitalize z-mb-24">{`${jobTitle} Industry Statistics`}</h3>
          }
        />
      </div>
    </Fragment>
  );
};

export default Industries;
